<template>
  <div style="width: 150px">
    <b-badge
      :variant="badgeVariant"
      :style="badgeStyle"
      class="status-badge text-container"
    >
      {{ statusName }}
    </b-badge>
  </div>
</template>

<script>
import {
  BBadge,
} from 'bootstrap-vue'
import {
  mapGetters,
} from 'vuex'

export default {
  name: 'OrderStatusBadge',
  components: {
    BBadge,
  },
  props: {
    statusKey: {
      type: String,
      default: 'N/A',
    },
  },
  computed: {
    ...mapGetters(['statusList']),
    statusColor() {
      const obj = this.statusList.find(n => n.key === this.statusKey)
      return obj ? obj.color : 'primary'
    },
    statusName() {
      const obj = this.statusList.find(n => n.key === this.statusKey)
      return obj ? obj.name : 'N/A'
    },
    isHexColor() {
      return typeof this.statusColor === 'string' && this.statusColor.startsWith('#')
    },
    badgeVariant() {
      // If it's a hex color, use secondary variant and apply inline styles
      if (this.isHexColor) {
        return 'secondary'
      }
      // If it's a Bootstrap variant name, use it with 'light-' prefix
      const bootstrapVariants = ['primary', 'success', 'danger', 'warning', 'info', 'secondary']
      if (bootstrapVariants.includes(this.statusColor)) {
        return `light-${this.statusColor}`
      }
      // Default fallback
      return 'light-primary'
    },
    badgeStyle() {
      // Apply inline styles only if we have a hex color
      if (this.isHexColor) {
        const hexColor = this.statusColor
        // Convert hex to rgba for background with opacity
        const r = parseInt(hexColor.slice(1, 3), 16)
        const g = parseInt(hexColor.slice(3, 5), 16)
        const b = parseInt(hexColor.slice(5, 7), 16)
        return {
          backgroundColor: `rgba(${r}, ${g}, ${b}, 0.12)`,
          color: hexColor,
        }
      }
      return {}
    },
  },
}
</script>

<style scoped>
@media (max-width: 767px) { /* Apply the style only for screens up to 767px wide (mobile) */
  .status-badge {
    display: inline-block;
    white-space: normal;
  }
}
.text-container {
  max-width: 100%; /* Set your desired maximum width */
  word-wrap: break-word; /* Break long words to the next line */
  white-space: normal; /* Allow whitespace to wrap */
}
</style>
<!-- <style scoped>
    /*.status-badge {*/
    /*    color: white;*/
    /*    padding-left: 10px;*/
    /*    padding-right: 10px;*/
    /*    padding-top: 2px;*/
    /*    padding-bottom: 2px;*/
    /*    font-weight: normal;*/
    /*    font-size: smaller;*/
    /*    display: inline-block;*/
    /*}*/
</style> -->
